module.exports = __webpack_public_path__ + "img/king.8f830775.png";